import { jsx as _jsx } from "react/jsx-runtime";
import { ModuleFE_Toaster } from '@nu-art/thunderstorm-frontend/index';
import { compare, Second } from '@nu-art/ts-common';
import { TS_EditableItemComponent } from '@nu-art/thunderstorm-frontend/components/TS_EditableItemComponent/TS_EditableItemComponent';
import { DefaultEditor_InputText } from '@app/styles/frontend/ui-manager/ui-components';
export class QRangeInputV3 extends TS_EditableItemComponent {
    deriveStateFromProps(nextProps, state) {
        state = super.deriveStateFromProps(nextProps, state);
        return state;
    }
    toastError = (message) => {
        ModuleFE_Toaster.toastError(message, 3 * Second);
    };
    translateValueToString = (value) => {
        if (!value)
            return '';
        if (value[0] === undefined || value[1] === undefined)
            return '';
        if (value[0] === value[1])
            return `${(value[0] || value[0] === 0) ? value[0] : ''}`;
        return `${value[0]} - ${value[1]}`;
    };
    translateStringIntoValue = (str) => {
        if (str.length === 0)
            return undefined;
        // Trim the input to remove any leading or trailing spaces
        str = str.trim();
        // Attempt to directly parse the input as a single number first
        const singleNumber = Number(str);
        if (!isNaN(singleNumber)) {
            return [singleNumber, singleNumber];
        }
        // If not a single number, then check for a range
        // Use a regex that matches a hyphen potentially surrounded by whitespace, ensuring it doesn't match negative numbers
        const split = str.split(/(?<!^)\s*-\s*/);
        // Ensure there are exactly two parts and both are valid numbers
        if (split.length === 2) {
            const numbers = split.map(Number);
            if (numbers.some(isNaN)) {
                this.toastError('Each part must be a valid number');
                return undefined;
            }
            if (numbers[0] > numbers[1]) {
                this.toastError('Range maximum cannot be less than range minimum');
                return undefined;
            }
            return numbers;
        }
        // If it doesn't match any known patterns, return an error
        this.toastError('Incorrect format for input');
        return undefined;
    };
    render() {
        const prop = this.props.prop;
        const value = this.props.value ?? this.state.editable.get(prop);
        const valueAsString = this.translateValueToString(value);
        return _jsx(DefaultEditor_InputText, { editable: this.state.editable, prop: prop, className: this.props.className, disabled: this.props.disabled, placeholder: this.props.placeholder, type: 'text', value: valueAsString, showErrorTooltip: this.props.showErrorTooltip, onChange: async (value) => {
                const _value = this.translateStringIntoValue(value);
                if (compare(_value, this.state.editable.get(prop)))
                    return;
                if (_value) {
                    await this.state.editable.updateObj({ [prop]: _value });
                }
                if (!_value && this.props.shouldReset)
                    await this.state.editable.updateObj({ [prop]: [0, 0] });
                this.props.onChange?.();
            } });
    }
}
//# sourceMappingURL=QRangeInputV3.js.map